<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Pirkumu grozs</div>
    </div>
  </div>

  <cart-steps step="3" :confirmed="1"></cart-steps>
  <div class="ui attached segment">
    <div class="ui error icon message" >
      <i class="warning sign icon"></i>
      <div class="content">
        <div class="header">
          Uzmanību!
        </div>
        <p>Maksājums nav apstiprināts</p>
      </div>
    </div>
  </div>


</div>
</template>

<script>
import CartSteps from './CartSteps'

export default {
  components: {
    CartSteps
  },

  activated: function() {
    //user is returned to this page from paysera, after this submit data to backend and redirect to topup page
    //using this as paysera puts data attribute in front of url where router cannot access it
    var url = require('url');
    var query = url.parse(window.location.href, true).query;
  


  },


}
</script>



// WEBPACK FOOTER //
// CartCancelationPage.vue?d1b0fb0c